<template>
  <div ref="gameViewOverlay" class="overlay" id="game-view-overlay" />
</template>

<script>
export default {
  props: {
    isCZRegulatory: { type: Boolean, default: false },
    isSKRegulatory: { type: Boolean, default: false },
    userDevice: { type: String, default: 'd' }
  },
  mounted () {
    this.$store.dispatch('setFullScreenEvents');

    const heightOffset = { topPosition: 0, totalOffset: 0 };
    if (this.isCZRegulatory) { heightOffset.topPosition = 45; heightOffset.totalOffset = 90; }
    else if (this.isSKRegulatory) heightOffset.totalOffset = 45;

    this.$refs.gameViewOverlay.style.top = `${heightOffset.topPosition}px`;
    this.$refs.gameViewOverlay.style.height = `calc(100% - ${heightOffset.totalOffset}px)`;
    this.$refs.gameViewOverlay.style.pointerEvents = 'auto';

    this.$refs.gameViewOverlay.addEventListener('click', () => this.$store.dispatch('openFullScreen', this.$parent.$refs.gameView), false);
  }
}
</script>

<style scoped>
.overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
  z-index: 999;
  pointer-events: none;
}
</style>
